<template>
  <v-container class="white-wrapper" fluid>
    <!-- <phone-overlay :show="!auth_sms" :back="true"></phone-overlay> -->
    <div
      style="max-width:25rem;margin:0 auto;height:100%;display:flex;flex-direction:column;justify-content:space-between;padding: 0 1rem;"
    >
    테스트 페이지1
      <v-form ref="form" v-model="valid" lazy-validation>
 

    <v-btn
          class="font-weight-bold mb-4"
          color="primary"
          @click="getPushKey"
          x-large 
        >
            <!-- 등록하기  -->
            PushKey
        </v-btn>


        <div style="margin-top:30px;">
          <!--카드 일련번호를 등록해 주세요.-->
            <label>{{$t('nft.regCardMsg')}}</label><br>                     
        </div>

        <v-text-field
          
          class="swap-input-wrapper"
          :label="$t('nft.serialNumber')"
          :placeholder="$t('nft.serialNumber')"
          v-model="ncode"          
          @keypress="filterNumber()"
          required
        >          
        </v-text-field>
      </v-form>
      <div>
        <!-- <v-btn class="font-weight-bold" @click="reset" x-large block>
            {{ $t('swap.reset') }}
          </v-btn> -->
        <v-btn
          class="font-weight-bold mb-4"
          color="primary"
          @click="submitNft"
          x-large
          block
          :disabled="loading || disabled || !valid "
        >
            <!-- 등록하기  -->
            {{$t('nft.registration')}}
        </v-btn>
      </div>
    </div>
 
    <v-dialog v-model="messageModal" max-width="30rem">
      <v-card>
        <v-card-title></v-card-title>
        <v-card-text v-html="message"> </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="messageModal = false">
            {{ $t('swap.messageModal.close') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import BigNumber from 'bignumber.js'
import PhoneOverlay from '../../components/PhoneOverlay.vue'

export default {
  components: { PhoneOverlay },
  data: () => ({
    ncode: null , 
    fee: null,
    valid: true,
    fromType: null,
    toAddress: '',
    configId: null,
    toType: null,
    fromAmount: null,
    toAmount: 0,
    amountRules: [(v) => !!v || '', (v) => v > 0 || ''],
    coinRules: [(v) => !!v || ''],
    messageModal: false,
    message: null,
    confirmDialog: false,
    fee: null,
    noConfig: false,
    hash: null
  }),
  computed: {
    auth_sms() {
      return true ; 
      return this.$store.getters.user.auth_sms === 'Y' ? true : false
    },
    myWalletAdress() {
      return this.$store.getters.user.wallet_address
    },
    fromWallet() {
      console.log("dev: " ,  this.$store.getters.wallet ) ; 
      return this.$store.getters.wallet.filter((item) => item.name === 'ETH' ||item.name === 'USDT' ||item.name === 'CCC1'   )

      return this.$store.getters.wallet
    },
    ethBalance() {
      return this.$store.getters.wallet.filter((i) => i.name === 'ETH')[0]
        .balance
    },
    toWallet() {
      // console.log("To : " , this.$store.getters.wallet.filter((item) => item.name === 'CCC' ||item.name === 'LSS'  )  )  ;
      return this.$store.getters.wallet.filter((item) => item.name === 'CCC' ||item.name === 'LSS'  )

      // if (this.fromType === 'plp')
      //   return this.$store.getters.wallet.filter((item) => item.name === 'PLI')
      // if (this.fromType === 'pli')
      //   return this.$store.getters.wallet.filter((item) => item.name === 'PLP')
      // return this.$store.getters.wallet.filter(
      //   (item) => item.name === 'PLP' || item.name === 'PLI'
      // )
    },
    upperFrom() {
      return this.fromType ? this.fromType.toUpperCase() : null
    },
    upperTo() {
      return this.toType ? this.toType.toUpperCase() : null
    },
    prices() {
      return this.$store.getters.prices
    },
    loading() {
      return this.$store.getters.loading
    },
    disabled() {
      return !this.ncode 
    },
    fromBalance() {
      return this.fromType
        ? this.fromWallet.filter((item) => item.value === this.fromType)[0]
            .balance
        : 0
    },
    availableToken() {
      if (!this.fromType || !this.fromAmount || this.fromAmount <= 0)
        return false

      return (
        BigNumber(this.fromAmount).toNumber() <=
        BigNumber(this.fromBalance).toNumber()
      )
    },
    perToken() {
///      console.log(  BigNumber('1').times(this.prices[`price_${this.toType}`]).toFixed(8)   , this.prices[`price_${this.toType}`] ) ;
///      console.log(  BigNumber('1').times(this.prices[`price_${this.toType}`]) .div(this.prices[`price_${this.fromType}`]).toFixed(8)   , this.prices[`price_${this.fromType}`] ) ;

      return this.comma(
        BigNumber('1')
          .times(this.prices[`price_${this.toType}`])
          .div(this.prices[`price_${this.fromType}`])
          .toFixed(8)
      )
    },
    expectFee() {
      return this.fromType === 'pli'
        ? this.fromAmount
          ? BigNumber(this.fromAmount)
              .div(BigNumber('1000'))
              .toFixed(2, 1)
          : 0
        : (this.fee * 60000) / 10000000000
    },
    isAvailableFee() {
      if (this.fromType === 'eth' || this.fromType === 'pli')
        return BigNumber(this.fromBalance).isGreaterThanOrEqualTo(
          BigNumber(this.fromAmount).plus(BigNumber(this.expectFee))
        )
      return this.expectFee <= this.ethBalance
    }
  },
  created() {  
  },
  mounted(){
    
     const isUIWebView = () => {
            return navigator.userAgent
              .toLowerCase()
              .match(/\(ip.*applewebkit(?!.*(version|crios))/);
      };  
      const receiver = isUIWebView() ? window : document; 
      receiver.addEventListener("message", this.onMessageHandler);       

  } , 
  methods: {
    onMessageHandler(e) {
          
          try { 
            const event = JSON.parse(e.data);             
            const token = event.token;            
            const os = event.os;

            // register_push
            const params = { os: os  , token : token }
            this.$store
              .dispatch('register_push', params)
              .then((res) => {                     
              })
              .catch((err) => {                
              }) ;
            // register_push 

            }catch(error)  {                     
              console.error('error') ; 
              return  ;              
            }
    }, 

    sendMessage(str){
      window.ReactNativeWebView.postMessage(str);
    },

    receiveMessage(event){
      alert("받은 데이터(Web) : "+event.data);
      this.postMessage = event.data;
    } , 

    filterNumber : function(evt) {
      evt = (evt) ? evt : window.event;
      let expect = evt.target.value.toString() + evt.key.toString();
      
      if (!/^[-+]?[0-9]*\.?[0-9]*$/.test(expect)) {
        evt.preventDefault();
      } else {
        return true;
      }
    }, 
    imgSrc(item) {
      
      let src
      try {
        src = require(`@/assets/svg/${item + '-logo.svg'}`)
      } catch (e) {
        try {
          src = require(`@/assets/svg/${item + '-logo.png'}`)
        } catch (e) {
          src = require(`@/assets/svg/ETH-logo.svg`)
        }
      } ; 

      return src
    } ,
    onKeydown(e) {
      if (
        e.keyCode === 101 ||
        e.keyCode === 69 ||
        e.keyCode === 45 ||
        e.keyCode === 43
      )
        e.preventDefault()

      let regx = /^\d*[.]\d{8}$/
      if (this.fromType === 'usdt') regx = /^\d*[.]\d{6}$/
      if (this.fromType === 'pli' || this.fromType === 'plp')
        regx = /^\d*[.]\d{2}$/
      const _value = e.target.value

      if (regx.test(_value)) e.preventDefault()
    },
    getPushKey() { 
       window.ReactNativeWebView.postMessage(
              JSON.stringify({ key: "token" })
          );

    }, 
    submitNft() { 
      return true;        
    },
    reset() {
      this.$refs.form.reset()
    }
  }
}
</script>

<style lang="scss" scoped>
.select-item .col {
  padding: 0 0.5rem;
}
.select-item {
  width: 100%;
  color: #121212;
}
.swap-icon {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 1rem auto;
}
.bottom-btn-left {
  position: fixed;
  width: 50%;
  left: 0;
  bottom: 55px;
}
.bottom-btn-right {
  position: fixed;
  width: 50%;
  left: 50%;
  bottom: 55px;
}
.label-wrapper {
  font-weight: bold;
  font-size: 0.85rem;
  margin-left: 1rem;
}
.max-btn {
  display: flex;
  justify-content: flex-end;
  height: 0;
  transform: translateY(-15px);
}
// .mask-wrapper {
//   background-color: #fff;
//   margin: 0 13px 0 12px;
//   text-align: right;
//   transform: translateY(-56px);
// }
// .placeholder-wrapper {
//   text-align: left;
//   color: #797979;
// }
.bottom-btn-right.theme--light.v-btn.v-btn--disabled,
.bottom-btn-right.theme--light.v-btn.v-btn--disabled:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
  background-color: #c8bae8 !important;
  color: #fff !important;
}
.sheet-title {
  font-size: 1.2rem;
  font-weight: bold;
  text-align: center;
  margin-bottom: 1.2rem;
}
.sheet-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0.8rem auto;
}
.logo-circle {
  background-color: #e2e2e2;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 50%;
  margin-right: 0.2rem;
}
</style>
